import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { ListLeadsTotals } from "../types";

async function getListLeadsTotalsRequest(
  workspaceId: string,
  listId: string,
): Promise<ListLeadsTotals> {
  const { included, excluded } = await get(
    `workspaces/${workspaceId}/lists/${listId}/totals`,
  );

  return { included, excluded };
}

export default function useListLeadsTotals({ listId }: { listId: string }) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { listsKeys } = getQueryKeys(workspaceId);

  const {
    data: totals,
    isLoading: isLoadingTotals,
    error: totalsError,
    refetch: refetchTotals,
  } = useQuery({
    queryKey: listsKeys.leadsTotals(listId),
    queryFn: () => getListLeadsTotalsRequest(workspaceId, listId),
  });

  return { totals, isLoadingTotals, totalsError, refetchTotals };
}
